import {CircularProgress, Fade, Grid, Paper} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route} from 'react-router';
import {Switch} from 'react-router-dom';
import {isMatchingRoute} from '../../../router/Tools';
import Error404 from '../../common/ErrorsPages/Error404';
import AuthCss from './css/AuthCss';
import {routes} from './routes/routes';

class Auth extends Component {
  render() {

    if (this.props.auth.fetching) {
      return (
        <Fade
          in={true}
          style={{
            transitionDelay: '800ms',
          }}
          unmountOnExit
        >
          <CircularProgress/>
        </Fade>
      )
    }

    if (!routes.find(r => isMatchingRoute(r.path, this.props.routepathname))) return <Error404/>;
    const {classes} = this.props;
    return (
      <Grid
        container
        alignItems='center'
        justify='center'
        className={classes.loginContainer}
      >
        <Paper elevation={20} className={classes.paper}>
          <Switch>
            {routes.map(r => <Route path={r.path} exact={r.exact} key={r.path} component={r.component}/>)}
          </Switch>
        </Paper>
      </Grid>
    );
  }
}

Auth = withStyles(AuthCss)(Auth);

Auth = connect((store) => {
  return {
    auth: store.auth,
    routepathname: store.router.location.pathname
  }
})(Auth);

export default Auth
